'use es6';

import Raven from 'Raven';
import { logError } from './loggers';
const SENTRY_EXTRA_OPTS = {
  fingerprint: ['laboratory-lib', 'network']
};
export function createErrorObject(caller, error) {
  const errorObject = new Error(`[laboratory-lib "${caller}"] ${error}`); // The Error stack is irrelevant as the Error doesn't originate from here

  delete errorObject.stack;
  return errorObject;
}
export function logAndReportError(error, extra = {}) {
  // First logs the error in the console and then attempts to report it to Sentry
  // Which still could fail and if it does, we log the failure exception
  logError(error);

  try {
    const captureMethod = typeof error === 'string' ? 'captureMessage' : 'captureException';
    Raven[captureMethod](error, Object.assign({}, SENTRY_EXTRA_OPTS, {}, extra));
  } catch (failureError) {
    logError(failureError);
  }
}